import React, { useState } from "react";
import PropTypes from "prop-types";

const AddToWalletModal = ({ onClose, onSubmit, jobOptions }) => {
  const [jobId, setJobId] = useState("");
  const [amount, setAmount] = useState("");
  const [reason, setReason] = useState("");

  const options =
    Array.isArray(jobOptions) && jobOptions.length
      ? jobOptions
      : [];

  const handleSubmit = () => {
    if (!jobId || !amount || !reason) return;

    onSubmit({
      jobId,
      amount: Number(amount),
      reason,
    });

    onClose();
  };

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/40">
      <div className="bg-white w-full max-w-xl rounded-lg shadow-xl flex flex-col max-h-[90vh]">
        <div className="flex items-center justify-between px-6 py-4 border-b">
          <h3 className="text-lg font-semibold text-gray-800">
            Add To Wallet
          </h3>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 text-xl"
          >
            Ã—
          </button>
        </div>

        <div className="px-6 py-4 overflow-y-auto space-y-4 flex-1">
          <div>
            <label className="text-sm font-medium">Job ID</label>
            <select
              className="w-full mt-1 border rounded px-3 py-2"
              value={jobId}
              onChange={(e) => setJobId(e.target.value)}
            >
              <option value="">Select job</option>
              {options.map((id) => (
                <option key={id} value={id}>
                  {id}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label className="text-sm font-medium">Amount (Rs.)</label>
            <input
              type="number"
              className="w-full mt-1 border rounded px-3 py-2"
              placeholder="Enter amount"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
            />
          </div>

          <div>
            <label className="text-sm font-medium">Reason</label>
            <textarea
              className="w-full mt-1 border rounded px-3 py-2"
              placeholder="Reason for adding to wallet"
              value={reason}
              onChange={(e) => setReason(e.target.value)}
            />
          </div>
        </div>

        <div className="flex justify-end gap-3 px-6 py-4 border-t">
          <button
            onClick={onClose}
            className="px-4 py-2 text-sm border rounded"
          >
            Cancel
          </button>
          <button
            onClick={handleSubmit}
            className="px-4 py-2 text-sm bg-blue-600 text-white rounded"
          >
            Add
          </button>
        </div>
      </div>
    </div>
  );
};

AddToWalletModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  jobOptions: PropTypes.arrayOf(PropTypes.string),
};

export default AddToWalletModal;
